import { parseResponse } from 'utils/parseResponse';
import { endpoints } from '../endpoints';
import { getHeader } from './generalApi';

export async function getLeaseholdTypes() {
  return fetch(`${endpoints.vtLeaseholdTypes}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}
